/*
	日期：2025/08/25
	地点：四川 成都
	作者：终结司令官
	
	介绍：首页数据模拟
	
	- Powered by finalcommander.com
	- Supported by IOE.TOP
*/

import Vue from 'vue'
import Vuex from 'vuex'
import tab from './tab'
//import tab from './tab.js'

// 引入 Vuex
Vue.use(Vuex)

// 创建 Vuex 实例 
export default new Vuex.Store({
	modules: {
		tab
	}
})